import { connect } from 'react-redux'
import { checkQingJia } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkQingJia
}
const mapStateToProps = (state) => {
  return {
    ...state.QingJiaCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
